// -------------------------------
// CatMullRom winline animator
// -------------------------------
(function () {
  class GameWinlineCatMullRomAnimator {
    constructor() {
      this.WINLINE_ANIMATION_TIME = 1000;
      this.ended = false;
      this.winlineFinished = false;
      this.winlinesPlaying = false;
      this.fullWinAmount = 0;
      this.winlineContainer = undefined;
      this.symbolFlickers = [];

      this.winlines = [];
      this.winlinePool = [];
      this.winlinesCreated = 0;

      this.symbolWidth = 168;

      this.winlineWidth = this.symbolWidth * gameData.numReels;

      Reflex.registerEventHandler("ready", this.onLayoutComplete.bind(this));
      messageBus.subscribe(
        "spinner:WinningLinesEvent",
        this.doPayWins.bind(this)
      );
    }

    getWinline() {
      let movie = undefined;

      if (this.winlinePool.length > 0) {
        movie = this.winlinePool.pop();
      } else {
        movie = resourceManager.createObject(
          "movie",
          "Winline" + this.winlinesCreated,
          "slotContainer:winlineContainer",
          {
            definition: "winlineAnim",
          }
        );
        movie.loop = false;
        ++this.winlinesCreated;
      }
      return movie;
    }

    cleanUp() {
      for (let i = 0; i < this.winlines.length; ++i) {
        this.winlines[i].winline.visible = false;
        this.winlines[i].winline.gotoAndStop(0);
        this.winlinePool.push(this.winlines[i].winline);
      }
      this.winlines = [];
      for (let index = 0; index < this.symbolFlickers.length; index++) {
        const flicker = this.symbolFlickers[index];
        flicker.flicker.kill();
        if (flicker.symbol.filters[0]) {
          flicker.symbol.filters[0].reset();
        }
        flicker.symbol.filters = [];
      }
      this.symbolFlickers = [];
    }

    begin() {
      this.ended = false;
    }

    end() {
      this.ended = true;
    }

    playAnimations(sequence, symbols, slotMachine, callback) {
      const self = this;
      this.winAmount = sequence[0].winAmount;
      this.callback = callback;
      this.winlineFinished = false;
      this.currentWinlineAnimations = [];

      this._completeCb = callback;
      this.symbols = symbols;
      this.slotMachine = slotMachine;

      console.log("CURRENT WIN LINE: ");
      console.log(symbols);

      for (let i = 0; i < symbols.length; ++i) {
        let cell = symbols[i].cell;
        let symPos = slotMachine.getSymbolPosition(cell.reel, cell.row, false);

        const symbol = resourceManager.get(
          `slotContainer:reelContainer:reel${cell.reel}:symbol${cell.row}`
        );
        this.winAnim(symbol);
        let symId = 0;
        if (
          (cell.row - 1 >= 0 && symbols[i].symbolId === 42) ||
          (cell.row - 1 >= 0 && symbols[i].symbolId === 43)
        ) {
          let symId = gameController.slotMachine.getSymbolId(
            cell.reel,
            cell.row - 1
          );
          if (symId === symbols[i].symbolId) {
            const otherSymbol = resourceManager.get(
              `slotContainer:reelContainer:reel${cell.reel}:symbol${
                cell.row - 1
              }`
            );
            this.winAnim(otherSymbol);
          }
        }
        if (
          (cell.row + 1 <= 2 && symbols[i].symbolId === 42) ||
          (cell.row + 1 <= 2 && symbols[i].symbolId === 43)
        ) {
          symId = gameController.slotMachine.getSymbolId(
            cell.reel,
            cell.row + 1
          );
          if (symId === symbols[i].symbolId) {
            const otherSymbol = resourceManager.get(
              `slotContainer:reelContainer:reel${cell.reel}:symbol${
                cell.row + 1
              }`
            );
            this.winAnim(otherSymbol);
          }
        }
        if (symbols[i].symbolId === 43) {
          symId = gameController.slotMachine.getSymbolId(cell.reel, 0);
          if (symId === symbols[i].symbolId) {
            const otherSymbol = resourceManager.get(
              `slotContainer:reelContainer:reel${cell.reel}:symbol${0}`
            );
            this.winAnim(otherSymbol);
          }
        }

        if (cell.row + 2 <= 2 && symbols[i].symbolId === 43) {
          symId = gameController.slotMachine.getSymbolId(
            cell.reel,
            cell.row + 2
          );
          if (symId === symbols[i].symbolId) {
            const otherSymbol = resourceManager.get(
              `slotContainer:reelContainer:reel${cell.reel}:symbol${
                cell.row + 2
              }`
            );
            this.winAnim(otherSymbol);
          }
        }
        for (
          let index = 0;
          index < gameController.wildLandAnimator._movies.length;
          index++
        ) {
          const wildCell =
            gameController.wildLandAnimator._movies[index]._trackInfo.cell;
          if (
            cell.reel === wildCell.reel &&
            gameController.wildLandAnimator._movies[index]._trackInfo
              .symbolId === symbols[i].symbolId
          ) {
            self.winAnim(gameController.wildLandAnimator._movies[index]);
          }
        }

        for (
          let index = 0;
          index < gameController.symbolAnimator._movies.length;
          index++
        ) {
          const wildCell =
            gameController.symbolAnimator._movies[index]._trackInfo.cell;
          if (
            cell.reel === wildCell.reel &&
            gameController.symbolAnimator._movies[index]._trackInfo.symbolId ===
              symbols[i].symbolId
          ) {
            self.winAnim(gameController.symbolAnimator._movies[index]);
          }
        }

        for (
          let index = 0;
          index < gameController.wildFire.movies.length;
          index++
        ) {
          if (cell.reel === index && 43 === symbols[i].symbolId) {
            self.winAnim(gameController.wildFire.movies[index]);
          }
        }
        let winline = this.getWinline();

        winline.visible = true;

        winline.anchor.set(0.5);

        winline.position.set(symPos.x, symPos.y);

        this.winlines.push({
          winline: winline,
          posX: symPos.x,
          posY: symPos.y,
        });

        winline.gotoAndPlay(0);
        // winline.onComplete = () => {
        //   winline.visible = false;
        // };
      }
    }

    winAnim(symbol) {
      const filter = new PIXI.filters.ColorMatrixFilter();
      // filter.brightness(2, false);
      symbol.filters = [filter];

      const params = { brightness: 1 };

      const flickerTimeline = gsap.timeline({
        onComplete: () => {
          filter.reset();
          symbol.filters = [];
        },
      });

      const flickerCount = 2;
      const segmentDuration = 0.8 / flickerCount;

      // const flickerCount = 1;
      // const segmentDuration = 1 / flickerCount;

      for (let i = 0; i < flickerCount; i++) {
        const randomBrightness = 2;
        //gsap.utils.random(0.3, 2);

        // Tween to a bright/dim state.
        flickerTimeline.to(params, {
          brightness: randomBrightness,
          duration: segmentDuration / 2,
          ease: "power1.inOut",
          onUpdate: () => {
            // Update the filter’s brightness on each tick.
            // The second parameter (false) means we’re not scaling the current matrix.
            filter.brightness(params.brightness, false);
          },
        });

        flickerTimeline.to(params, {
          brightness: 1,
          duration: segmentDuration / 2,
          ease: "power1.inOut",
          onUpdate: () => {
            filter.brightness(params.brightness, false);
          },
        });
      }
      this.symbolFlickers.push({ symbol: symbol, flicker: flickerTimeline });
    }

    skipAnimation() {
      if (this.currentWinlineAnimations !== undefined) {
        this.winlinesPlaying = false;
        this.animationTime = this.totalAnimationTime;

        this.currentWinlineAnimations.forEach(function (animData) {
          animData.particles.particleEmitter.emit = false;
          animData.particles.visible = false;
        });
      }

      this.cleanUp();
    }

    onGameConfigEvent(gameConfigTask) {
      this.numReels = gameConfigTask.data.slotConfig.startingSymbols.length;
      this.numRows =
        gameConfigTask.data.slotConfig.startingSymbols[0].symbols.length;
      this.numWinlines = gameConfigTask.data.slotConfig.defaultNumLines;

      this.spots = [];
      let winlines = gameConfigTask.data.slotConfig.paylines;
      for (let i = 0; i < winlines.length; i++) {
        this.spots.push(winlines[i].spots);
      }
    }

    onOrientationChange() {
      this.winlines.forEach((winline) => {
        winline.winline.position.set(winline.posX, winline.posY);
      });
    }

    onStakeChanged(stake) {
      this.stake = stake;
    }

    clearWinlines() {
      this.cleanUp();
    }

    onLayoutComplete() {
      this.winlineContainer = resourceManager.get(
        "slotContainer:winlineContainer"
      );
      messageBus.subscribe(
        "spinner:GameConfigEvent",
        this.onGameConfigEvent.bind(this)
      );
      messageBus.subscribe(
        "stake:stakeChanged",
        this.onStakeChanged.bind(this)
      );

      Reflex.registerEventHandler(
        "orientationChange",
        this.onOrientationChange.bind(this)
      );
    }

    doPayWins(task) {
      this.fullWinAmount = task.data.totalLineWinnings;
    }
  }

  let create = function () {
    return new GameWinlineCatMullRomAnimator();
  };
  resourceManager.registerSharedPlugin(
    "GameWinlineCatMullRomAnimatorEx",
    create
  );
})();
